<template>
<div class="chapter">
<div class="inner_page">
<p class="block_9" style="margin-top:20%;"><span class="text_4">In memory of my teachers, Professor Anthony C. Yu and Professor Nathan A. Scott Jr., from whom I learned the power of literature to illuminate the lives of persons otherwise forgotten.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?4ab86473